/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassValue
 */
export interface ClassValue {
    /**
     * 
     * @type {string}
     * @memberof ClassValue
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ClassValue
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof ClassValue
     */
    numcontacts: number;
}


/**
 * Check if a given object implements the ClassValue interface.
 */
export function instanceOfClassValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "numcontacts" in value;

    return isInstance;
}

export function ClassValueFromJSON(json: any): ClassValue {
    return ClassValueFromJSONTyped(json, false);
}

export function ClassValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'numcontacts': json['numcontacts'],
    };
}

export function ClassValueToJSON(value?: ClassValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'numcontacts': value.numcontacts,
    };
}

